import { COLORS } from '@/styles/colors';
import { bodySmall, poppinsMediumFont } from '@/styles/typography';
import styled from 'styled-components';

export const ChipWrapper = styled.div<{ isActive: boolean; disabled: boolean }>`
  padding: 10px 16px;
  border-radius: 20px;
  border: 1px solid ${COLORS.grey[300]};
  background-color: ${COLORS.white};
  border: 1px solid ${COLORS.grey[300]};
  cursor: pointer;
  ${bodySmall};
  ${poppinsMediumFont};

  &:hover {
    background-color: ${COLORS.grey[300]};
  }

  ${({ isActive }) =>
    isActive &&
    `
      background-color: ${COLORS.black};
      color: ${COLORS.white};

      &:hover {
        background-color: ${COLORS.black};
      }
    `};
`;
